import React from "react";
import PageHeader from "../../../Components/PageHeader";
import { Tabs } from "antd";
import CompletedTab from "../../../Components/InstructorTabs/CompletedPayoutTab";
import PendingPayouts from "../../../Components/InstructorTabs/PendingPayouts";
import "../../../Styles/Users.css";

const Payout = () => {
  const onChange = (key) => {
    console.log(key);
  };
  const items = [
    {
      key: "1",
      label: "Completed payouts",
      children: <CompletedTab />,
    },
    {
      key: "2",
      label: "Pending payouts",
      children: <PendingPayouts />,
    },
  ];

  return (
    <div>
      <div className="d-flex gap-3 px-3">
        <div className="mt-5 pt-5 d-flex flex-column gap-4 w-100">
          <PageHeader title={" Instructor payouts"} />
          <div className="payouts_page">
            <h6>LIST OF PAYOUTS</h6>
            <Tabs defaultActiveKey="1" items={items} onChange={onChange} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Payout;
